import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SystemApiClient } from "../clients/system-api/SystemApiClientp";
import {
  AdministrationResultStatus,
  MembershipData,
  MembershipTypeData,
  MembershipTypeDataPaginationDataAdministrationResult,
  PaginationArgs,
  MembershipDataPaginationDataAdministrationResult } from "../clients/system-api/SystemApiClient";

@Injectable({
    providedIn: 'root'
  })
  export class MembershipService {
    constructor (private systemApiClient: SystemApiClient) { }

    retrieveAllMembershipTypes(args: PaginationArgs | undefined): Observable<MembershipTypeDataPaginationDataAdministrationResult>{
        return this.systemApiClient.retrieveAllMembershipTypes(args);
    }

    addMembershipType(body: MembershipTypeData | undefined): Observable<AdministrationResultStatus>{
      return this.systemApiClient.addMembershipType(body);
    }

    editMembershipType(body: MembershipTypeData | undefined): Observable<AdministrationResultStatus>{
      return this.systemApiClient.editMembershipType(body);
    }

    addMembership(body: MembershipData | undefined): Observable<AdministrationResultStatus>{
      return this.systemApiClient.addMembership(body);
    }
    
    editMembership(body: MembershipData | undefined): Observable<AdministrationResultStatus>{
      return this.systemApiClient.editMembership(body);
    }

    retrieveAllMemberships(body: PaginationArgs | undefined): Observable<MembershipDataPaginationDataAdministrationResult>{
      return this.systemApiClient.retrieveAllMemberships(body);
    }
}
